import { useAPIQuery as usePackageAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { showServerErrorAlert } from "../utils/serverErrorAlert";

const wrapMutate = (mutateFn) => (options = {}) => {
    const {
        errorMessageFromServer,
        defaultErrorMessage,
        customErrorMessage,
        onError,
        ...rest
    } = options;

    const shouldShowAlert =
        Boolean(errorMessageFromServer) ||
        Boolean(defaultErrorMessage) ||
        Boolean(customErrorMessage);

    if (!shouldShowAlert) {
        return mutateFn(options);
    }

    return mutateFn({
        ...rest,
        errorMessageFromServer: false,
        defaultErrorMessage: false,
        customErrorMessage: undefined,
        onError: (error) => {
            showServerErrorAlert(error, customErrorMessage);
            onError?.(error);
        },
    });
};

export const useAPIQuery = (params) => {
    const api = usePackageAPIQuery(params);
    return {
        ...api,
        useCreate: wrapMutate(api.useCreate),
        useUpdate: wrapMutate(api.useUpdate),
        useDelete: wrapMutate(api.useDelete),
    };
};
